/* eslint-disable custom-rules/no-direct-antd-message */
import { ChatMessage } from '@ant-design/pro-chat';
import { CloseCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';

interface ErrorMessageProps {
  className?: string;
  message: ChatMessage;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ className, message }) => {
  const errorContent = message.error.message.replace(
    'response error, status:',
    ''
  );
  return (
    <div
      id={message.id}
      className={classNames(
        className,
        'ant-alert',
        'ant-alert-error',
        'message-error'
      )}
      role="alert"
    >
      <CloseCircleFilled className="ant-alert-icon" />
      <div className="ant-alert-content">
        <div className="ant-alert-message">{errorContent}</div>
      </div>
    </div>
  );
};

export default ErrorMessage;
